import React,{useContext, useEffect,useState} from 'react';
import MainMenu from './../../../components/mainMenu/MainMenu';
import LeftSitebarMenu from './../../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from './../../../components/rightSitebarMenu/RightSitebarMenu';
import closerIcon from '../../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../../App';
import { fundraiserPostDetails } from '../../../api';
import { useParams } from 'react-router-dom';
import FundraisersVideoSection from '../components/fundraisersVideoSection/FundraisersVideoSection';
import FundraisersTextSection from '../components/fundraisersTextSection/FundraisersTextSection';
import FundraisersRouting from '../components/fundraisersRouting/FundraisersRouting';

const FundraisersDetails = () => {
    const [ fundraiserSingleDatas , setFundraiserSingleDatas ] = useState([])
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'blogs';
        setPageName.blogs.left = false;
        setPageName.blogs.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.blogs.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.blogs.right = status
            setShowHideSidebar(newStatus)
        }
    }
    // Single Fundrasers Data Fetch 
    const paramsId = useParams()
    useEffect( ()=>{
        fundraiserPostDetails().then( 
            data => setFundraiserSingleDatas(data[paramsId.id])
        )
    },[])
    console.log("fandraisers Single Data ", fundraiserSingleDatas)
    return (
        <div>
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-xxl">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.blogs?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}

                    {/* Center Align Items Code start Here*/}
                    <div className="col-12 col-lg-10">
                        <div className="row mb-5 gap-3 gap-lg-0">
                            {/* Video Play Section */}
                            <FundraisersVideoSection />
                            {/* Text Or OverView Section */}
                            <FundraisersTextSection />
                        </div>
                        <div className="row">
                            {/* Fundraisers Routing or Nested Routing Page here */}
                            <FundraisersRouting />
                        </div>
                    </div>    
                    <div className={`col-12 col-lg-4  d-none-lg ${showHideSidebar?.blogs?.right ? 'd-blog right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end my-2">
                        <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                            <img src={closerIcon} alt="" className='close-menu-button' />
                        </div>
                        </div>
                        <RightSitebarMenu />
                    </div>          
                </div>
            </div>
        </div>
    );
};

export default FundraisersDetails;